import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
  loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  retrieveCustomers({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("customer/retrieveCustomers").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveCustomersByName({ commit } , name) {
    commit("SET_LOADING", true);
    return getAPI("customer/retrieveCustomersByName/" + name).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  deleteCustomer({ commit } , id) {
    commit("SET_LOADING", true);
    return postAPI("customer/deleteCustomer/" + id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveCustomerById({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("customer/retrieveCustomerById" , id)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveCustomer({ commit }, customer) {
    commit("SET_LOADING", true);
    return postAPI("customer/saveCustomer", customer).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  countCustomers({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("customer/count").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },


};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};